import * as moment from "moment";
export const timestampToDate = (date) => {
  if (date) {
    return moment(date).format("YYYY-MM-DD");
  }

  return null;
};
